angular.module('agreements')
    .controller('AgreementShowController', function ($scope, $rootScope, $uibModalInstance, Agreement, data, AgreementService, AgreementConst, Principal, InvoiceService) {
        this.AgreementService = AgreementService
        this.$onInit = () => {
            Agreement.get({id: data.id}).$promise
                .then(result => {
                    this.item = result
                    Principal.currentUser().then(user => {
                        this.isWorker = this.item.worker != null && this.item.worker.id === user.id
                    })
                    Agreement.children({id: this.item.id}).$promise.then(result => this.children = result)
                    Agreement.touches({id: this.item.id}).$promise.then(items => this.touches = items)
                    this.canReadContractBgt = ['AGREEMENT', 'ORDER', 'OFFER'].includes(this.item.type) && Principal.hasAnyAuthority(['ROLE_CONTRACT_BGT_READ', 'ROLE_ADMIN'])
                    this.canSeeDF = ['AGREEMENT', 'ORDER'].includes(this.item.type) && Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_MODULE'])
                    InvoiceService.workflow.load().then(configuration => {
                        this.canSeeSubcontractorStatements =
                            configuration.subcontractorStatements.enabled
                            && this.item.type === 'AGREEMENT'
                            && this.item.subcontractorStatementsEnabled
                            && Principal.hasAnyAuthority([
                                'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_READ',
                                'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_WRITE_WITH_READ_ACCESS',
                                'ROLE_ADMIN'
                            ])
                    })
                    this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD']) && ['AGREEMENT', 'ANNEX', 'ORDER'].includes(this.item.type)
                    this.businessThreadResourceType = this.item.type === 'ORDER' ? 'AGREEMENT_ORDER' : 'AGREEMENT'
                })
                .catch(() => $uibModalInstance.dismiss())

            this.canModifyTouches = Principal.hasAnyAuthority(['ROLE_CONTRACT_ALL', 'ROLE_CONTRACT_PROJECT_ASSIGNED'])
        }

        this.cancel = () => $uibModalInstance.dismiss()

        $scope.$on(AgreementConst.eventUpdate, () => {
            $rootScope.$broadcast('document.comments.reload', this.item.id)
            this.$onInit();
        })
        $scope.$on('agreement.deleted', () => this.cancel())
        $scope.$on("file.saved", () => this.$onInit())
    })
